<div class="w-full p-5">
  <form class="form-grid" [formGroup]="formPartner">
    <div class="">
      <ng-content select="[inputImage]"> </ng-content>
    </div>
    <div class="grid w-full grid-cols-2 gap-4">
      <div class="form-group">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="name"> Nome Fantasia: </label>
        <input
          type="text"
          id="name"
          class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          formControlName="name"
        />
      </div>

      <div class="form-group">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="trading"> Razão Social: </label>
        <input
          type="text"
          id="trading"
          class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          formControlName="trading"
        />
      </div>

      <div class="form-group">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="type"> Tipo Parceiro: </label>
        <ng-select
          notFoundText="Nenhum item encontrado"
          [searchable]="false"
          placeholder="Tipo de Parceiro"
          id="type"
          formControlName="type"
        >
          <ng-option *ngFor="let opcaoTipoPartner of opcoesTipoPartner" [value]="opcaoTipoPartner">
            {{ opcaoTipoPartner }}
          </ng-option>
        </ng-select>
      </div>

      <div class="form-group">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="document"> CNPJ: </label>
        <input
          type="text"
          id="document"
          class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          formControlName="document"
          mask="00.000.000/0000-00"
        />
      </div>

      <div class="form-group">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="email"> Email: </label>
        <input
          type="email"
          id="email"
          class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          formControlName="email"
        />
      </div>

      <div class="form-group">
        <label class="block text-gray-700 text-sm font-bold mb-2" for="phone"> Contato: </label>
        <input
          type="email"
          id="phone"
          class="form-input appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          formControlName="phone"
          mask="(00) 0000-0000||(00) 0 0000-0000"
        />
      </div>
    </div>
  </form>
</div>